<div class="common-app"
  id="centinela-app-template">
  @if (loadAllSources) {
    <div
      class="common-view"
      id="centinela-view-body">
      <router-outlet></router-outlet>
    </div>
  }
</div>
@if (showSpinnerLoading) {
  <spinner-window></spinner-window>
}
  <p-sidebar #iaAssitance 
    [(visible)]="sidebarVisible" 
    position="right" 
    styleClass="common-overlay__panel">
    <ng-template pTemplate="header" class="pepe">
       <div class="common-overlay__header-container">
        <p class="common-overlay__header-title">Asistente</p>
        <i class="lf-icon-ia common-icon__md common-icon__highlight"></i>
       </div>
       <button class="common-button__icon-sm-noborder"
       (click)="closeIaAssitance($event, iaAssitance)">
       <i class="lf-icon-close-thick common-icon__md"></i>
     </button>
    </ng-template>
    <ng-template pTemplate="content">
     <div class="common-overlay__content-container"
      [ngClass]="{'common-overlay__content-container--loader': showLoader}">
      @if(showLoader){
        <div class="common-spinner__block-spinner-description">
          <p-progressSpinner styleClass="common-spinner__progress-container-color-LG"
            ariaLabel="loading">
          </p-progressSpinner>
          <span class="common-spinner__description-text-color-grey"
            [afTranslate]="'common.analize-response'"></span>
        </div>
      }@else {
        @if(!errorInIaResponse){
          <div class="common-overlay__ia-question-block">
            <div class="common-overlay__ia-question-container">
              <p class="common-overlay__ia-question-text">
                {{field.label}}
              </p>
            </div>
          </div>
          <div class="common-overlay__ia-response-loader-block"
            [ngClass]="{'common-overlay__ia-response-loader-block--loader':generateResponse}">
            @if(generateResponse){
              <p-progressSpinner styleClass="common-spinner__progress-container-color-SM"
                ariaLabel="loading">
              </p-progressSpinner>
              <p class="common-overlay__ia-response-loader-text"
                [afTranslate]="'common.generate-response'">
              </p>
            }@else {
              <div class="common-overlay__ia-response-container">
                <div class="common-overlay__ia-response-container-text"
                  [innerHTML]="iaResponse"></div>
                <div class="common-overlay__copy-block">
                  <button class="common-button__icon-xs-noborder"
                    (click)="copyToClipboard()">
                    <i class="lf-icon-paste common-icon__sm common-icon__neutral"></i>
                  </button>
                </div>
              </div>
             
            }
          </div>
          <div class="common-overlay__ia-information-block">
            <i class="lf-icon-information common-icon__sm"></i>
            <p class="common-overlay__ia-information-text"
              [afTranslate]="'common.ia-information'"
                pTooltip="{{'common.ia-information-tooltip' |afTranslate}}"
                [tooltipPosition]="'bottom'"
                [tooltipStyleClass]="'common-overlay__ia-tooltip-neo'">
              _El asistente IA de Centinela analiza la documentación jurídica de Lefebvre junto con los datos de tu organización utilizando inteligencia artificial generativa. La responsabilidad final sobre la validez de la respuesta recae en el usuario.
            </p>
          </div>
          @if(showMaximizeInfo){
            <div class="common-status-message__g-container-info">
              <i class="lf-icon-info-full common-status-message__icon-md"></i>
              <div class="common-status-message__g-content">
                  <div class="common-status-message__g-icon-text-content">
                    <div class="common-status-message__g-title-subtitle">
                      <span class="common-status-message__g-subtitle">
                        {{phase.message}}
                      </span>
                    </div>
                    <button class="common-button__icon-xs-noborder"
                      (click)="notShowAgain()">
                        <i class="lf-icon-close-thick common-icon__sm"></i>
                    </button>
                  </div>
                  <div class="common-status-message__g-buttons-container">
                    <button class="common-button__link"
                      (click)="changeStep()">
                        <span class="common-button__link-text">
                         {{phase.hrefText}}
                          
                        </span>
                    </button>
                  </div>
              </div>
            </div>
          }
        }@else {
          <div class="common-status-message__g-container-alert">
            <i class="lf-icon-close-round-full common-status-message__icon-md"></i>
            <div class="common-status-message__g-content">
                <div class="common-status-message__g-icon-text-content">
                  <div class="common-status-message__g-title-subtitle">
                    <span class="common-status-message__g-subtitle"
                      [afTranslate]="'common.ia-error-response'">
                    </span>
                  </div>
                </div>
                <div class="common-status-message__g-buttons-container">
                  <button class="common-button__link"
                    (click)="retryIaResponse()">
                      <span class="common-button__link-text">
                        <span [afTranslate]="'common.ia-error-retry'"></span>
                      </span>
                  </button>
                </div>
            </div>
          </div>
        }
       
        
      }
     </div>
   </ng-template>
    <div class="common-toast__container common-overlay__copied-block-position"
      [ngClass]="{'common-overlay__copied-block-position--copied':textCopied}">
      <i class="lf-icon-check-round-full common-icon__md common-icon__sea-green"></i>
      <div class="common-toast__inner-text-container">
        <p class="common-toast__inner-text">
        {{textCopiedMessage}}
        </p>
      </div>
      <i class="lf-icon-close-thick common-icon__sm-clickable common-icon__sm-clickable--neutral-800"></i>
    </div>
  </p-sidebar>

